package ru.education.building.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.ui.graphics.Color
import org.koin.compose.koinInject
import org.koin.dsl.module

val WhiteColorTheme = lightColorScheme(
    background = Color(0xFFFFFFFF),
    onBackground = Color(0xFF1C1B1F),
    surface = Color(0xFFFFFFFF),
    onSurface = Color(0xFF1C1B1F),
    // Небольшой серый для контейнеров, чтобы отделять карточки от фона
    surfaceVariant = Color(0xFFF5F5F5),
    // Тот же акцент, что и в темной теме, для брендинга
    primary = Color(0xFF3F51B5),
    onPrimary = Color(0xFFFFFFFF),
    // По мере необходимости можно дополнить secondary/tertiary/error и др.
)

val AmoledDarkColorTheme = darkColorScheme(
    background = Color(0xFF000000),
    onBackground = Color(0xFFFFFFFF),
    surface = Color(0xFF000000),
    onSurface = Color(0xFFFFFFFF),
    // Небольшой серый для контейнеров, чтобы отделять карточки от фона
    surfaceVariant = Color(0xFF0A0A0A),
    // Акцент: холодный синий
    primary = Color(0xFF3F51B5),
    onPrimary = Color(0xFFFFFFFF),
    // Дополнительно по желанию:
    // outline = Color(0xFF2A2A2A),
)

@Composable
fun CustomAppTheme(content: @Composable () -> Unit) {
    val themeMode: MutableState<ThemeMode> = koinInject()
    val isDarkTheme = when (themeMode.value) {
        ThemeMode.LIGHT -> false
        ThemeMode.DARK  -> true
        ThemeMode.AUTO  -> isSystemInDarkTheme()
    }

    MaterialTheme(
        colorScheme = if (isDarkTheme) AmoledDarkColorTheme else WhiteColorTheme,
        content = {

            content()
        }
    )
}

val themeModule = module {
    single { ThemePreferences() }
    single<MutableState<ThemeMode>> {
        val prefs = get<ThemePreferences>()
        mutableStateOf(prefs.themeMode)
    }
}
